import axios from 'axios';
import emailjs from 'emailjs-com';
import { API_ROOT } from '../configs/env-vars';


const sendNotification = ()=>{
    emailjs
      .send(
        'service_vn6b95c',
        'template_8cnl761',
        {
          server:false
        },
        'IzWQhwBBVxE78qkxH'
      )
      .then(
        (response) => {
          console.log('Email sent successfully:', response);
        },
        (error) => {
          console.error('Email failed to send:', error);
        }
      );
}

export  const fetchExternalData = async (data) => {
    try {
      const reqData = {
          method: 'post',
          url: `${API_ROOT}/scrape`,
          // headers: {}, 
          data: {
              ...data, // This is the body part https://brasero-france.com
          }
        };
      const response = await axios(reqData);
      const replacedHtmlContent = await response.data.replace(/data-src="([^"]*)"/g, 'src="$1"')
      return replacedHtmlContent;
    } catch (error) {
       sendNotification()
       console.log('error')
       console.error('Error fetching external data:');
    }
};

export  const fetchSearchData = async (data) => {
    try {
      const reqData = {
          method: 'post',
          url: `${API_ROOT}/api/search`,
          // headers: {}, 
          data: {
              ...data, // This is the body part https://brasero-france.com
          }
        };
      const response = await axios(reqData);
      return response;
    } catch (error) {
       sendNotification()
       console.log('error')
       console.error('Error fetching external data:');
    }
};